import { useState, type FormEvent } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { useCreatePortalUser } from "@/api/mutations/portalUsers";

// Portal-Admin anlegen. Mindestlaenge 12 validiert der Server (Single Source) —
// hier nur ein Hinweis.
export function CreatePortalUserDialog({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const create = useCreatePortalUser();

  function submit(e: FormEvent) {
    e.preventDefault();
    create.mutate(
      { email: email.trim(), password },
      {
        onSuccess: () => {
          setEmail("");
          setPassword("");
          onOpenChange(false);
        },
      },
    );
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="create-admin-dialog">
        <DialogHeader>
          <DialogTitle>Admin anlegen</DialogTitle>
          <DialogDescription>Passwort mindestens 12 Zeichen.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="adm-email">Email</Label>
            <Input id="adm-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-email" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="adm-pass">Passwort</Label>
            <Input id="adm-pass" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-password" />
          </div>
          {create.isError && (
            <div className="text-sm text-danger" data-testid="create-admin-error">
              {create.error.message}
            </div>
          )}
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)} disabled={create.isPending}>
              Abbrechen
            </Button>
            <Button type="submit" disabled={create.isPending} data-testid="create-admin-submit">
              {create.isPending ? "…" : "Anlegen"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
